export default {
  rac:{
    driverClass: "oracle.jdbc.driver.OracleDriver",
    jdbcUrl: 'tpl:jdbc:oracle:thin:@(DESCRIPTION = (ADDRESS = (PROTOCOL = TCP)(HOST = ${ip})(PORT = ${port})) (CONNECT_DATA = (SERVER = DEDICATED) (SERVICE_NAME = ${SID})))',
    preferredTestQuery: "select 'X' from dual",
  },
  oracle: {
    driverClass: "oracle.jdbc.driver.OracleDriver",
    jdbcUrl: 'tpl:jdbc:oracle:thin:@${ip}:${port}:${SID}',
    preferredTestQuery: "select 'X' from dual",
  },
  mysql: {
    driverClass: "com.mysql.cj.jdbc.Driver",
    jdbcUrl:"tpl:jdbc:mysql://${ip}:${port}/${SID}?useSSL=false&useUnicode=true&characterEncoding=UTF-8&serverTimezone=Hongkong&zeroDateTimeBehavior=CONVERT_TO_NULL",
    preferredTestQuery: "select 'X'",
  },
  dameng:{
    driverClass: "dm.jdbc.driver.DmDriver",
    jdbcUrl:"tpl:jdbc:dm://${ip}<#if port?has_content>:${port}</#if>/${SID}",
    preferredTestQuery: "select 'X'",
  },
  kingbase8:{
    driverClass: "com.kingbase8.Driver",
    jdbcUrl:"tpl:jdbc:kingbase8://${ip}:${port}/${SID}",
    preferredTestQuery: "select 'X' from dual",
  },
  kingbase7:{
    driverClass: "com.kingbase.Driver",
    jdbcUrl:"tpl:jdbc:kingbase8://${ip}:${port}/${SID}",
    preferredTestQuery: "select 'X' from dual",
  },
  shenTong:{
    driverClass: "com.oscar.Driver",
    jdbcUrl:"tpl:jdbc:oscar://${ip}:${port}/${SID}",
    preferredTestQuery: "select 'X' from dual",
  },
  sqlServer:{
    driverClass: "com.microsoft.sqlserver.jdbc.SQLServerDriver",
    jdbcUrl:"tpl:jdbc:sqlserver://${ip}:${port};DatabaseName=${SID}",
    preferredTestQuery: "select 'X'",
  },
  oceanbase:{
    driverClass: "com.alipay.oceanbase.obproxy.mysql.jdbc.Driver",
    jdbcUrl:"tpl:jdbc:oceanbase://${ip}:${port}/${SID}?rewriteBatchedStatements=true&allowMultiQueries=true&useLocalSessionState=true&useUnicode=true&characterEncoding=utf-8&useInformationSchema=true",
    preferredTestQuery: "select 'X'",
  },
  postgresql:{
    driverClass: "org.postgresql.Driver",
    jdbcUrl:"tpl:jdbc:postgresql://${ip}:${port}/${SID}",
    preferredTestQuery: "select 'X'",
  },
  hhdb:{
    driverClass: "org.hhdbsql.Driver",
    jdbcUrl:"tpl:jdbc:hhdbsql://${ip}:${port}/${SID}",
    preferredTestQuery: "select 'X'",
  },
  highgo:{
    jdbcUrl:"tpl:jdbc:highgo://${ip}:${port}/${SID}?currentSchema=${SID}",
    driverClass: "com.highgo.jdbc.Driver",
    preferredTestQuery: "select 'X'",
  }
};



// WEBPACK FOOTER //
// ./src/modules/index/views/maintain/dbTypeMap.js